module.exports = __webpack_public_path__ + "img/logo_misty_oracle.18e53d19.jpg";